import React from 'react'
import PropTypes from 'prop-types'
import SelectAic from '@/components/shared/components/selectAic'
import DateRange from '@/components/shared/components/dateRange'
import Button from '@/components/shared/components/Button/Button'
import { AnimatePresence, motion } from 'framer-motion'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import schema from './schemaFormBoking'
import { forIn, get, isEmpty } from 'lodash'

// styles
import './styles.bh.scss'
import moment from 'moment'

const errorMessageForHotel = 'Please select a hotel from the list'
const errorMessageForDateRange = 'Please choose a date range'

export default function BookingInputs({ data }) {
  const { hotelList, hotelLoading, dateFormat } = data
  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })
  const errorHotelSelected = get(errors, ['hotelSelected'], null)
  const errorDateRange = get(errors, ['dateRange'], null)

  const onSubmit = (data) => {
    const hotelSelected = hotelList.find((hotelInput) => hotelInput.value === data.hotelSelected)
    const dateFormatByUrl = get(hotelSelected, ['acf', 'bookingEngine', 'dateFormat'])
    const endDate = moment(data.dateRange.end).format(dateFormatByUrl)
    const startDate = moment(data.dateRange.start).format(dateFormatByUrl)
    const baseUrl = get(hotelSelected, ['acf', 'bookingEngine', 'bookingEngineUrl'])

    const queryParams = {
      hotel: get(hotelSelected, ['acf', 'bookingEngine', 'id']),
      level: 'hotel',
      ...forIn(get(hotelSelected, ['acf', 'bookingEngine', 'globalParams']), (value, key) => ({
        [`${key}`]: value,
      })),
      chain: get(hotelSelected, ['acf', 'bookingEngine', 'chain']),
      arrive: startDate,
      depart: endDate,
    }

    let finalUrl = new URL(baseUrl)
    let params = new URLSearchParams(queryParams)
    finalUrl.search = params.toString()
    window.open(finalUrl, '_blank')
  }

  return (
    <div className="containerInputs">
      <span className="titleClass">{data.title}</span>
      <div className="roundedContainer">
        <AnimatePresence>
          {hotelLoading ? (
            <div className="contentRounded">
              <div className="h-[58px] bg-isabelline rounded-full w-full xl:max-w-[380px] animate-pulse" />
              <div className="h-[58px] bg-isabelline rounded-full w-full xl:max-w-[380px] animate-pulse" />
              <div className="h-[58px] bg-eerie-black rounded-full w-full xl:max-w-[163px] animate-pulse" />
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} className="contentRounded">
              <motion.div
                style={{
                  position: 'relative',
                }}
                transition={{
                  duration: 0.6,
                  delay: 0.3,
                }}
                viewport={{
                  once: true,
                }}
                initial={{ opacity: 0, left: '70px' }}
                whileInView={{ opacity: 1, left: '0px' }}
                exit={{ opacity: 0 }}
                className="!min-w-[38%]"
              >
                <SelectAic
                  isError={!isEmpty(errorHotelSelected)}
                  className="!w-full"
                  placeholder="Choose hotel"
                  options={hotelList}
                  onChange={(valueSelect) => {
                    setValue('hotelSelected', valueSelect.value)
                  }}
                />
                {!isEmpty(errorHotelSelected) ? (
                  <span className="ml-[15px] paragraph text-red-500 block text-lg">
                    {errorMessageForHotel}
                  </span>
                ) : null}
              </motion.div>
              <motion.div
                // style={{
                //   position: 'relative',
                // }}
                transition={{
                  duration: 0.6,
                  delay: 0.6,
                }}
                viewport={{
                  once: true,
                }}
                initial={{ opacity: 0, left: '70px' }}
                whileInView={{ opacity: 1, left: '0px' }}
                exit={{ opacity: 0 }}
                className="!min-w-[38%]"
              >
                <div className="!h-[58px]">
                  <DateRange
                    isError={!isEmpty(errorDateRange)}
                    dateFormat={dateFormat}
                    onChange={(valueDate) => {
                      const startDate = get(valueDate, ['start'], null)
                      const endDate = get(valueDate, ['end'], null)
                      if (endDate && startDate) {
                        setValue('dateRange.start', startDate)
                        setValue('dateRange.end', endDate)
                      }
                    }}
                    classNameInput="!bg-transparent"
                  />
                </div>

                {!isEmpty(errorDateRange?.start) || !isEmpty(errorDateRange?.end) ? (
                  <span className="ml-[15px] paragraph text-red-500 block text-lg">
                    {errorMessageForDateRange}
                  </span>
                ) : null}
              </motion.div>
              <div className="!h-[58px]">
                <Button variant="default" isSubmit name="BOOK NOW" type="submit" showLabel />
              </div>
            </form>
          )}
        </AnimatePresence>
      </div>
    </div>
  )
}

BookingInputs.propTypes = {
  data: PropTypes.object,
}
